/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Gadgets(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5002 15.083C17.9143 15.083 18.25 15.4189 18.2502 15.833C18.2502 16.2472 17.9144 16.583 17.5002 16.583H2.50015C2.08594 16.583 1.75015 16.2472 1.75015 15.833C1.75033 15.4189 2.08605 15.083 2.50015 15.083H17.5002ZM15.0002 4.24999C15.42 4.24999 15.8224 4.41703 16.1193 4.71386C16.4161 5.01072 16.5831 5.41319 16.5832 5.833V12.5C16.5832 12.9199 16.4162 13.3222 16.1193 13.6191C15.8224 13.9161 15.4201 14.083 15.0002 14.083H5.00015C4.58023 14.083 4.17794 13.9161 3.88101 13.6191C3.58408 13.3222 3.41714 12.9199 3.41714 12.5V5.833C3.41723 5.41319 3.58416 5.01071 3.88101 4.71386C4.17793 4.41703 4.5803 4.24999 5.00015 4.24999H15.0002ZM5.00015 5.74999C4.97813 5.74999 4.95717 5.75888 4.94156 5.77441C4.92601 5.78996 4.91723 5.81102 4.91714 5.833V12.5C4.91714 12.5221 4.92593 12.543 4.94156 12.5586C4.95719 12.5742 4.97805 12.583 5.00015 12.583H15.0002C15.0223 12.583 15.0431 12.5742 15.0587 12.5586C15.0744 12.543 15.0832 12.5221 15.0832 12.5V5.833C15.0831 5.81101 15.0743 5.78996 15.0587 5.77441C15.0431 5.75888 15.0222 5.74999 15.0002 5.74999H5.00015Z"
        fill="#35424F"
      />
    </svg>
  )
}

Gadgets.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Gadgets
